import * as React from "react";
import {
  Text,
  CardBody,
  Card,
  CardFooter,
  Stack,
  Heading,
  CardHeader,
  useDisclosure,
  Button,
  StackDivider,
  Box,
  Badge,
  Flex,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const MapCarrosFiliais = ({ carro, getCarros }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  let navigate = useNavigate();
  const [size, setSize] = React.useState("md");

  return (
    <Card>
      <CardHeader>
        <Heading size="lg" mb={-15} textTransform="uppercase">
          PLACA: {carro.Carro.placa}
        </Heading>
      </CardHeader>

      <CardBody>
        <Stack divider={<StackDivider />} spacing="2">
          <Box>
            <Heading size="xs" textTransform="uppercase">
              MODELO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.modelo}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              ANO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.ano}
            </Text>
          </Box>

          <Box>
            <Heading size="xs" textTransform="uppercase">
              ÚLTIMO KM REGISTRADO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.u_km_registrado}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              PRÓXIMA REVISÃO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.p_revisao}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              ÚLTIMA REVISÃO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.u_revisao}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              ÚLTIMA TROCA DE PNEU:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.u_troca_pneu}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              FILIAL:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.filial}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              OBSERVAÇÃO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.Carro.obs}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              ID DO CARRO:
            </Heading>
            <Text pt="2" fontSize="md">
              {carro.id}
            </Text>
          </Box>
          <Box>
            <Heading size="xs" textTransform="uppercase">
              Status:
            </Heading>
            <Text pt="2" fontSize="md">
              <Badge
                variant="solid"
                colorScheme={
                  carro.Carro.status === "Ativo"
                    ? "green"
                    : carro.Carro.status === "Inativo"
                    ? "red"
                    : carro.Carro.status === "Manutenção"
                    ? "yellow"
                    : null
                }
                textAlign={"center"}
              >
                {carro.Carro.status}
              </Badge>
            </Text>
          </Box>
        </Stack>
      </CardBody>

      <CardFooter>
        <Button
          colorScheme="blue"
          width={"100%"}
          onClick={() =>
            navigate(`/filial/${carro.Carro.filial}/carro/${carro.id}`)
          }
        >
          Ver Carro
        </Button>
      </CardFooter>
    </Card>
  );
};

export default MapCarrosFiliais;
